module.exports = __webpack_public_path__ + "static/media/Devices.219a0e3e.png";